import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03de0ddc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "workouts",
  class: "view"
}
const _hoisted_2 = { class: "container workouts-container" }
const _hoisted_3 = { class: "display-filters" }
const _hoisted_4 = { class: "list-container" }

import { ComputedRef, computed, ref } from 'vue'
  import { useI18n } from 'vue-i18n'

  import WorkoutsFilters from '@/components/Workouts/WorkoutsFilters.vue'
  import WorkoutsList from '@/components/Workouts/WorkoutsList.vue'
  import { AUTH_USER_STORE, SPORTS_STORE } from '@/store/constants'
  import { ISport, ITranslatedSport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import { useStore } from '@/use/useStore'
  import { translateSports } from '@/utils/sports'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n()
  const store = useStore()

  const authUser: ComputedRef<IUserProfile> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.AUTH_USER_PROFILE]
  )
  const sports: ComputedRef<ISport[]> = computed(
    () => store.getters[SPORTS_STORE.GETTERS.SPORTS]
  )
  const translatedSports: ComputedRef<ITranslatedSport[]> = computed(() =>
    translateSports(sports.value, t)
  )
  const hiddenFilters = ref(true)

  function toggleFilters() {
    hiddenFilters.value = !hiddenFilters.value
  }

return (_ctx: any,_cache: any) => {
  return (_unref(authUser).username)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["filters-container", { hidden: hiddenFilters.value }])
          }, [
            _createVNode(WorkoutsFilters, {
              sports: _unref(translatedSports),
              authUser: _unref(authUser),
              onFilter: toggleFilters
            }, null, 8, ["sports", "authUser"])
          ], 2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", { onClick: toggleFilters }, [
              _createElementVNode("i", {
                class: _normalizeClass(`fa fa-caret-${hiddenFilters.value ? 'down' : 'up'}`),
                "aria-hidden": "true"
              }, null, 2),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`workouts.${hiddenFilters.value ? 'DISPLAY' : 'HIDE'}_FILTERS`)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(WorkoutsList, {
              user: _unref(authUser),
              sports: _unref(translatedSports)
            }, null, 8, ["user", "sports"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})